import request from "../api/httpClient.js";
import getEndpoint from "../utils/getEndpoint";

export const getComments = async (publicationId, query) => {
  const comments = await request(
    getEndpoint("publication", "getComments", publicationId),
    { query },
  );
  return comments.data;
};

export const deleteComment = async (publicationId, commentId) => {
  await request(
    getEndpoint("publication", "deleteComment", publicationId, commentId),
  );
};

export const createComment = async (publicationId, text) => {
  const comment = await request(
    getEndpoint("publication", "createComment", publicationId),
    {
      body: { text },
    },
  );
  return comment.data;
};
